import { render, staticRenderFns } from "./Graduates.vue?vue&type=template&id=64746f1c&scoped=true"
import script from "./Graduates.vue?vue&type=script&lang=js"
export * from "./Graduates.vue?vue&type=script&lang=js"
import style0 from "./Graduates.vue?vue&type=style&index=0&id=64746f1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64746f1c",
  null
  
)

export default component.exports